import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import {
  ConsistancyChamp,
  BodyProgressHero,
  BalancedPerformer,
  Places,
} from "@utils/defaultImages";
import stepBack from "@assets/images/stepsBack.jpg";
import { Card } from "@mui/material";
import { ChevronLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
const RanksWeekly = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const sliderData = [
    {
      RankImage: ConsistancyChamp,
      title: "First Quiz",
      unlockDate: "Unlocked on 5th July",
      description: "Achieved by completing your very first quiz.",
    },
    {
      RankImage: BodyProgressHero,
      title: "Rising Star",
      unlockDate: "Unlocked on 5th July",
      description: "Achieved when you reach 100 total points across quizzes.",
    },
    {
      RankImage: BalancedPerformer,
      title: "Consistent Player",
      unlockDate: "Unlocked on 5th July",
      description: " Achieved after you complete 5 quizzes.",
    },
  ];

  return (
    <>
      <div className="flex justify-end">
        <button
          className="bg-[#64DDFF] py-[12px] px-6 text-white rounded-full  mb-2 flex items-center gap-2"
          onClick={() => navigate(-1)}
        >
          <ChevronLeft
            className="w-6 h-6 bg-white rounded-full text-[#4CDBFF] p-[2px]"
            strokeWidth={4}
          />
          {t("quizGame.Return To Dashboard")}
        </button>
      </div>
      <Card className="p-5 !rounded-xl">
        <div
          className="p-6 w-full rounded-xl text-white bg-cover h-full relative" // Added relative here
          style={{ backgroundImage: `url(${stepBack})` }}
        >
          <h4 className="text-[16px] font-[Lato] text-white mb-3">
            Your Milestones
          </h4>
          <div
            className="
    [@media(max-width:639px)]:!max-w-[70vw]
    sm:max-w-[100%]
  "
          >
            <Swiper
              modules={[Navigation]}
              spaceBetween={20}
              slidesPerView={1}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                },
                700: {
                  slidesPerView: 2,
                  spaceBetween: 15,
                },
                1024: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                1280: {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
              }}
              loop={true}
                navigation={{
          nextEl: `.swiper-button-next-uniqueNext`,
          prevEl: `.swiper-button-prev-uniquePrev`,
        }}
              className="all-meals !px-[22px] sm:!px-[20px] !py-[25px] rounded-[10px] relative"
            >
              {/* Custom navigation buttons */}
               <div
          className={`swiper-button-prev-uniquePrev swiper-button-prev after:!text-[20px] after:!font-[600] !bg-white !rounded-full !w-9 !h-9 sm:!w-10 sm:!h-10 !flex !items-center !justify-center !shadow-md after:!text-[#0575e6] absolute top-1/2 !-left-0 z-10`}
        ></div>
        <div
          className={`swiper-button-next-uniqueNext swiper-button-next !bg-white after:!text-[20px] after:!font-[600] !rounded-full !w-9 !h-9 sm:!w-10 sm:!h-10 !flex !items-center !justify-center !shadow-md after:!text-[#0575e6] absolute top-1/2 !-right-0 z-10`}
        ></div>
              {sliderData?.map((data, index) => (
                <SwiperSlide key={index}>
                  <div className="flex justify-center w-full h-[100%]">
                    <div className="bg-white rounded-3xl w-full max-w-[80%] p-5 relative pb-8">
                      {" "}
                      {/* Added pb-8 for bottom padding */}
                      <h3 className="text-[16px] font-[600] font-[Lato] text-[#000] mt-[30%] text-center">
                        {data?.title}
                      </h3>
                      <div className="flex justify-center">
                        <button
                          disabled
                          className="bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] rounded-[22px] py-2 px-2 text-[12px] my-2"
                        >
                          Unlocked on 5th July
                        </button>
                      </div>
                      <div className="border border-[#DDDDDD] p-2 rounded-xl">
                        <p className="text-[12px] text-[#5C5C5C] text-center">
                          {data.description}
                        </p>
                      </div>
                      <img
                        src={data.RankImage}
                        alt="image"
                        className="absolute -top-[8%] left-1/2 -translate-x-1/2 z-[9] w-[40%] object-cover" // Adjusted positioning and added width
                        style={{ maxHeight: "none" }} // Ensure image isn't constrained
                      />
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </Card>
    </>
  );
};

export default RanksWeekly;
